// iOS now has protected returning sign-in. Android retains the prior lock policy.
export async function shouldExpireNativeSession(elapsedMs:number,readLock:()=>Promise<{enabled:boolean}>, secureIOS = false):Promise<boolean>{
 if(secureIOS)return Number.isFinite(elapsedMs)&&elapsedMs>=10*60*1000;
 if(!Number.isFinite(elapsedMs)||elapsedMs<=15*60*1000)return false;
 try{return (await readLock()).enabled!==true;}catch{return true;}
}
